import styles from './Tooltip.module.css';
import { Popover } from '@round/ui-kit';

type TooltipProps = {
    anchorElement: HTMLElement | SVGSVGElement | null;
    disabled?: boolean;
    value: string | number;
};

const Tooltip = ({ anchorElement, disabled, value }: TooltipProps) => {
    return (
        <Popover anchorElement={anchorElement} disabled={disabled} showOn="hover">
            <div className={styles.tooltip}>{value}</div>
        </Popover>
    );
};

export default Tooltip;
